import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResponse } from './page-response';

const API_URL = '/cargo/api/notifications';

export interface NotificationDto {
  id: number;
  title: string;
  body?: string;
  url?: string;
  /** CHAT_REQUEST_MESSAGE | CHAT_DEAL_MESSAGE | null (общее уведомление — переход только по url) */
  type?: string | null;
  entityId?: number | null;
  read: boolean;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(private http: HttpClient) {}

  getMyNotifications(page = 0, size = 20): Observable<PageResponse<NotificationDto>> {
    return this.http.get<PageResponse<NotificationDto>>(`${API_URL}/my`, {
      params: { page: String(page), size: String(size) }
    });
  }

  getUnreadCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${API_URL}/unread-count`);
  }

  markAsRead(id: number): Observable<void> {
    return this.http.patch<void>(`${API_URL}/${id}/read`, {});
  }

  markAllAsRead(): Observable<void> {
    return this.http.post<void>(`${API_URL}/read-all`, {});
  }
}
